var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66666 2.33333H9.99999C10.3536 2.33333 10.6928 2.47381 10.9428 2.72386C11.1928 2.97391 11.3333 3.31304 11.3333 3.66667V5H0.666656V3.66667C0.666656 3.31304 0.807132 2.97391 1.05718 2.72386C1.30723 2.47381 1.64637 2.33333 1.99999 2.33333H3.33332M8.66666 2.33333V1M8.66666 2.33333H3.33332M3.33332 1V2.33333M0.666656 5.33333V11.6667C0.666656 12.0203 0.807132 12.3594 1.05718 12.6095C1.30723 12.8595 1.64637 13 1.99999 13H9.99999C10.3536 13 10.6928 12.8595 10.9428 12.6095C11.1928 12.3594 11.3333 12.0203 11.3333 11.6667V5.33333",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.128e6da4a60bbda2c1568b20a1c8e7a9.svg";
export { ForwardRef as ReactComponent };